import { AfterViewInit, Component } from '@angular/core';
import { Chart } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom'
Chart.plugins.register({ zoomPlugin });

@Component({
  selector: 'homepage-chart',
  templateUrl: 'homepage-chart.html',
  inputs: ['chartInputData']
})
export class HomepageChartComponent implements AfterViewInit {

  chartInputData: any;
  charts: any = [];

  constructor() {
  }

  ngAfterViewInit(): void {
    console.log(this.chartInputData);
    for (let i = 0; i < this.chartInputData.length; i++) {
      let chart = this.chartInputData[i];
      let chartType = chart.type;
      let chartData = chart.data;
      let chartXTitle = chart.xAxisTitle;
      let chartYTitle = chart.yAxisTitle;
      let xAxisFormatter = chart.xAxisFormatter;
      let xAxisStacked = chart.xAxisStacked;
      let yAxisStacked = chart.yAxisStacked;
      let xAxisStepSize = chart.xAxisStepSize;
      let xAxisMaxTicksLimit = chart.xAxisMaxTicksLimit;
      let xAxisMax = chart.xAxisMax;
      let xAxisMin = chart.xAxisMin;
      let ctx = <HTMLCanvasElement>document.getElementById('myChart_' + i);
      ctx.height = 100;
      let myChart = new Chart(ctx, {
        type: chartType,
        data: chartData,
        options: {
          maintainAspectRatio: false,
          scales: chartXTitle == undefined && chartYTitle == undefined ? undefined : {
            xAxes: [{
              max: xAxisMax,
              min: xAxisMin,
              stacked: xAxisStacked,
              scaleLabel: {
                display: chartXTitle != undefined,
                labelString: chartXTitle
              },
              ticks: {
                stepSize: xAxisStepSize,
                maxTicksLimit: xAxisMaxTicksLimit,
                callback: function (value, index, ticks) {
                  if (xAxisFormatter == 'time') {
                    let date = new Date(0);
                    date.setSeconds(value);
                    return date.toISOString().substr(11, 5);
                  } else if (xAxisFormatter == 'week') {
                    let monday = new Date();
                    const dayOfWeek = monday.getDay(), firstDayOfWeek = new Date(monday), diff = dayOfWeek >= 1 ? dayOfWeek - 1 : 6 - dayOfWeek
                    firstDayOfWeek.setDate(monday.getDate() - diff)
                    firstDayOfWeek.setHours(0, 0, 0, 0)
                    monday = firstDayOfWeek;
                    monday.setTime(monday.getTime() + (value * 60 * 60 * 1000));
                    let weekday = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
                    return weekday[monday.getDay()];
                  }
                  return value;
                }
              }
            }],
            yAxes: [{
              stacked: yAxisStacked,
              ticks: {
                beginAtZero: true
              },
              scaleLabel: {
                display: chartYTitle != undefined,
                labelString: chartYTitle
              }
            }]
          },
          plugins: chartType != 'line' ? {} : {
            zoom: {
              zoom: {
                enabled: false,
                mode: 'xy'
              },
              pan: {
                enabled: false
              }
            }
          }
        }
      });
      this.charts.push(myChart);
    }
  }

  downloadChart(index) {
    let base64 = this.charts[index].toBase64Image('image/png', 1)
    let a = document.createElement("a");
    a.href = base64;
    a.download = "chart.png";
    a.click();
  }

}



// WEBPACK FOOTER //
// ./src/components/homepage-chart/homepage-chart.ts